import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Navbar from '../components/common/NavBar';
import MiniHero from '../components/common/MiniHero';
import Footer from '../components/common/Footer';
import { getUserLanguage } from '../utils/language';
import { useCart } from '@context/CartContext';
import { Link } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../config';

const Cart = () => {
  const language = getUserLanguage();
  const { cart, removeFromCart, updateQuantity } = useCart();
  const { ref: sectionRef, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  const calculateTotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  return (
    <div className="min-h-screen bg-black">
      <Navbar language={language} />
      <MiniHero title={language === 'cs' ? 'Košík' : 'Cart'} />
      <section className="py-20 bg-dark-gray relative" ref={sectionRef}>
        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          {cart.length === 0 ? (
            <div className="text-center text-white">
              <p>{language === 'cs' ? 'Váš košík je prázdný.' : 'Your cart is empty.'}</p>
              <Link to="/shop" className="btn-drift mt-4 inline-block">
                {language === 'cs' ? 'Přejít do e-shopu' : 'Go to Shop'}
              </Link>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 gap-6">
                {cart.map((item, index) => (
                  <div
                    key={item.id}
                    className={`drift-card ${inView ? 'animate-fade-in' : 'opacity-0'}`}
                    style={{ animationDelay: `${0.2 * index}s` }}
                  >
                    <div className="flex flex-col sm:flex-row items-center p-6">
                      <img
                        src={item.image_path ? `${IMAGE_BASE_URL}${item.image_path}` : '/images/products/placeholder.jpg'}
                        alt={item.translations?.[language]?.name || 'Product'}
                        className="w-24 h-24 object-cover rounded mr-4"
                      />
                      <div className="flex-1 text-center sm:text-left">
                        <h3 className="text-xl font-bold text-white">
                          {item.translations?.[language]?.name || 'Product'}
                        </h3>
                        <p className="text-gray-400">
                          {new Intl.NumberFormat(language === 'cs' ? 'cs-CZ' : 'en-US').format(item.price)}{' '}
                          {language === 'cs' ? 'Kč' : 'CZK'}
                        </p>
                      </div>
                      <div className="flex items-center mt-4 sm:mt-0">
                        <input
                          type="number"
                          min="1"
                          value={item.quantity}
                          onChange={(e) => updateQuantity(item.id, parseInt(e.target.value))}
                          className="w-16 bg-black border border-gray-700 text-white text-center py-1 px-2 rounded mr-4"
                        />
                        <button
                          onClick={() => removeFromCart(item.id)}
                          className="text-red-500 hover:text-red-700"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8 text-right">
                <p className="text-xl text-white">
                  {language === 'cs' ? 'Celkem:' : 'Total:'}{' '}
                  <span className="font-bold">
                    {new Intl.NumberFormat(language === 'cs' ? 'cs-CZ' : 'en-US').format(calculateTotal())}{' '}
                    {language === 'cs' ? 'Kč' : 'CZK'}
                  </span>
                </p>
                <Link to="/checkout" className="btn-drift mt-4 inline-block">
                  {language === 'cs' ? 'Pokračovat k objednávce' : 'Proceed to Checkout'}
                </Link>
              </div>
            </>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Cart;